export enum RetailOrderReportType {
    Info = 1,
    Invoice = 2,
    ChangeRequest = 3,
    ChangeRequestDetails = 4
}